// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2366":"0812dfb58a53b80f","5508":"fb774813ab5f826e"}[chunkId] + ".css";
};